export const REDIRECT_URI_PARAM = "redirect_uri";
